export default __webpack_public_path__ + "static/media/Group3.e84a98fb.png";